'use es6';

export default ((extractFn, defaultValue) => (config, runtimeOptions) => {
  const result = extractFn(config, defaultValue, runtimeOptions);
  return result === undefined ? defaultValue : result;
});